import { CodedCommentDefinitionModel } from "./";

export class AuctionLotCodedCommentModel {
    Id: number;
    AuctionLotId: number;
    CodedCommentDefinitionId: number;
    Quantity: number;

    CodedCommentDefinition: CodedCommentDefinitionModel;
}